<div class="media" *ngIf="isEmpty()">
    <fui-icon [height]="24" [icon]="'lock'" [width]="24"></fui-icon>
</div>
<fui-pin id="{{index}}-pin" *ngFor="let pin of value; let index = index"></fui-pin>
